module.exports = __webpack_public_path__ + "static/media/discover_1.4b89966c.svg";